<template>
    <div class="home">
        <Header ref="header" :type='headType'></Header>
        <BanIn url="image005">
            <template v-slot:text>
                <h2 class="inTit f48 wow fadeInLeft">业务与服务</h2>
                <div class="inDes f24 wow fadeInRight">
                    <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                </div>
            </template>
        </BanIn>
        <div class="mainBg">
            <div class="serBg">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">业务与服务</h2>
                    </div>
                    <ul class="serList">
                        <li v-for="(item, index) in serList" :key="index">
                            <div class="serItem flex">
                                <div class="serImg wow fadeInLeft">
                                    <img :src="item.image" alt="">
                                </div>
                                <div class="serText wow fadeInRight">
                                    <div class="serIcon">
                                        <img :src="item.small_icons" alt="">
                                    </div>
                                    <h3 class="serTit f24 color3 ellipsis">{{item.title}}</h3>
                                    <div class="serCon f18 color6 MultiLine">
                                        <div class="serDes">
                                            <p v-for="(a, i) in item.content_data" :key="i">{{ a.value_1 }}</p>
                                        </div>
                                    </div>
                                    <router-link class="hmMore f18 color_m" :to="'servicedetail?id=' + item.id">了解更多 +</router-link>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import BanIn from '@/components/BanIn.vue'
import Footer from '@/components/Footer.vue'
import { WOW } from 'wowjs'
import home from '@/api/home'
export default {
    name: 'Service',
    components: {
        Header,
        BanIn,
        Footer
    },
    data() {
        return {
            headType:3,
            serList:[
                {
                    id: 1,
                    image: require('@/assets/images/service/ser-img1.png'),
                    small_icons: require('@/assets/images/service/ser-icon1.png'),
                    title:'供应链物流',
                    content:'<p>▶　京津冀地区现有仓储管理面积20万平方米；</p><p>▶　配备专业自动升降平台、机动叉车、高位货架等专业作业设施；</p><p>▶　为很多一线品牌提供仓储代管服务如：格力、海尔、雪花、今麦郎等。</p>'
                },
                {
                    id: 2,
                    image: require('@/assets/images/service/ser-img2.png'),
                    small_icons: require('@/assets/images/service/ser-icon2.png'),
                    title:'行业物流',
                    content:'<p>▶　京津冀地区现有仓储管理面积20万平方米；</p><p>▶　配备专业自动升降平台、机动叉车、高位货架等专业作业设施；</p><p>▶　为很多一线品牌提供仓储代管服务如：格力、海尔、雪花、今麦郎等。</p>'
                },
                {
                    id: 3,
                    image: require('@/assets/images/service/ser-img3.png'),
                    small_icons: require('@/assets/images/service/ser-icon3.png'),
                    title:'行业物流',
                    content:'<p>▶　京津冀地区现有仓储管理面积20万平方米；</p><p>▶　配备专业自动升降平台、机动叉车、高位货架等专业作业设施；</p><p>▶　为很多一线品牌提供仓储代管服务如：格力、海尔、雪花、今麦郎等。</p>'
                },
                {
                    id: 4,
                    image: require('@/assets/images/service/ser-img4.png'),
                    small_icons: require('@/assets/images/service/ser-icon4.png'),
                    title:'仓储服务',
                    content:'<p>▶　京津冀地区现有仓储管理面积20万平方米；</p><p>▶　配备专业自动升降平台、机动叉车、高位货架等专业作业设施；</p><p>▶　为很多一线品牌提供仓储代管服务如：格力、海尔、雪花、今麦郎等。</p>'
                },
            ]
        }
    },

    computed: {
        
    },

    created() {
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()            

            // // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
            // this.$nextTick(() => {
            //   this.$wow.sync();
            // });
        });
        this.getList();
    },
    methods: {
        getList(){
            home.serList().then((res)=>{
                if (res.code === 1) {
                    this.serList = res.data.rows
                } else {
                    this.$toast(res.msg)
                }
            })
        }
    },
    destroyed(){
        
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/service.scss';
</style>